/*
 * Copyright (c) 2024-2025. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or
 * distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly
 * prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this
 * content, please contact the author for proper authorization and agreement.
 */
import React, { FC, useEffect, useRef, HTMLProps } from 'react';

interface TableIndeterminateCheckboxProps extends HTMLProps<HTMLInputElement> {
    indeterminate?: boolean;
}

const TableIndeterminateCheckbox: FC<TableIndeterminateCheckboxProps> = ({
                                                                             indeterminate,
                                                                             className = "",
                                                                             ...rest
                                                                         }) => {
    const ref = useRef<HTMLInputElement>(null!);

    useEffect(() => {
        if (typeof indeterminate === "boolean") {
            ref.current.indeterminate = !rest.checked && indeterminate;
        }
    }, [ref, indeterminate]);

    return (
        <input
            className={"TableIndeterminateCheckbox " + className + " cursor-pointer h-[20px] w-[20px]"}
            type="checkbox"
            ref={ref}
            {...rest}
        />
    );
};

export default TableIndeterminateCheckbox;